import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { DateService } from '../../../../shared/services/date.service';

export interface Package {
  id: string;
  type: string;
  price: number;
  amount: number;
  day: string;
  is_unlimited: boolean;
  title: string;
  data: string;
  voice: string | null;
  text: string | null;
  short_info: string;
  net_price: number;
}

export interface PackageHistoryItem {
  id: number;
  status: string;
  remaining: number;
  activated_at: string;
  expired_at: string;
  finished_at: string | null;
  package: Package;
}

export interface ESimPackageHistoryResponse {
  error: boolean;
  data: {
    data: PackageHistoryItem[];
  };
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-sim-package-history',
  templateUrl: './sim-package-history.component.html',
  styleUrl: './sim-package-history.component.scss'
})
export class SimPackageHistoryComponent implements OnInit {
  packageHistory: PackageHistoryItem[] = [];
  loading = true;
  error: string | null = null;
  iccid: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private authService: AuthService,
    private _dateService: DateService
  ) {}

  ngOnInit(): void {
    this.iccid = this.route.snapshot.paramMap.get('iccid');
    if (this.iccid) {
      this.loadPackageHistory(this.iccid);
    } else {
      this.error = 'SIM ICCID not found';
      this.loading = false;
    }
  }

  loadPackageHistory(iccid: string): void {
    // The JWT interceptor will automatically add the token header
    this.apiService.getData(`/api/airalo/sims/${iccid}/packages`).subscribe({
      next: (response: ESimPackageHistoryResponse) => {
        if (!response.error && response.data && response.data.data) {
          this.packageHistory = response.data.data;
        } else {
          this.error = 'Failed to load SIM package history';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching SIM package history:', err);
        this.error = 'Error loading SIM package history';
        this.loading = false;
      }
    });
  }

  goBack(): void {
    if (this.iccid) {
      this.router.navigate(['/app/sims', this.iccid]);
    } else {
      this.router.navigate(['/app/sims']);
    }
  }

  formatDate(dateValue: string): string {
    return this._dateService.getFormattedDateWithAMPM(dateValue);
  }
}